import { meta } from '../../../constants';

const { dataServiceApiURL, storageURL } = meta;

type BuildProxyURLArgs = {
  apiSource: string;
  params?: URLSearchParams | Record<string, string>;
  shouldUseWidgetDataService?: boolean;
};

export function buildProxyURL({
  apiSource,
  params = {},
  shouldUseWidgetDataService = false
}: BuildProxyURLArgs) {
  const apiURL = shouldUseWidgetDataService ? dataServiceApiURL : storageURL;
  const proxyURL = new URL(`${apiURL}/api/${apiSource}`);
  const searchParams = new URLSearchParams(params);

  searchParams.forEach((value, key) => {
    proxyURL.searchParams.append(key, value);
  });

  if (meta.proxyBypassCache) {
    proxyURL.searchParams.append('cache_bypass', 'true');
  }

  return proxyURL.toString();
}
